import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { message } from 'antd'
import type { LoginProgressState } from '../types'
import { usersReset, usersVerifyCode, usersResendCode, passwordUpdate, usersResendAlternateCode } from './helpers'
// import { updateUsers } from '../users'

const noLoginConfig = {
  loginProgress: null,
  verUser: false,
  username: null,
  token: null,
  isLoading: true,
  hasError: false,
}

interface UserCodePayload {
  loginProgress: string
  verUser: boolean
  username: string
  token: string
}

const initialState: LoginProgressState = { ...noLoginConfig }

export const loginProgressSlice = createSlice({
  name: 'LoginProgress',
  initialState,
  reducers: {
    fetchLogin: (state) => {
      state.isLoading = true
      state.hasError = false
    },
    setLogin: (state, action: PayloadAction<UserCodePayload>) => {
      state.loginProgress = action.payload.loginProgress
      state.verUser = false
      state.username = action.payload.username
      state.token = action.payload.token
      state.isLoading = false
      state.hasError = false
    },
    updateLogin: (state, action: PayloadAction<UserCodePayload>) => {
      state.loginProgress = action.payload.loginProgress
      state.verUser = true
      state.username = action.payload.username
      state.token = action.payload.token
      state.isLoading = false
      state.hasError = false
    },
    fetchLoginFailed: (state) => {
      state.loginProgress = null
      state.verUser = false
      state.username = null
      state.token = null
      state.isLoading = false
      state.hasError = true
    },
  },
})

// resetUsers

export const resetUsers = (email: string) => async (dispatch) => {
  try {
    dispatch(fetchLogin())
    const resetVerification = await usersReset(email)
    const { loginProgress, verUser, username, status, token } = resetVerification
    if (status === 'ok') {
      dispatch(
        setLogin({
          loginProgress,
          verUser,
          username,
          token,
        }),
      )
    }
    message.success('BNBGuard Login Authorisation Code')
  } catch (error) {
    localStorage.clear()
    sessionStorage.clear()
    message.error('User not found...')
    dispatch(fetchLoginFailed())
  }
}

export const verifyCode = (code: string, username: string) => async (dispatch) => {
  try {
    dispatch(fetchLogin())
    const resetVerification = await usersVerifyCode(code, username)
    const { loginProgress, status, token, verUser } = resetVerification
    if (status === 'ok') {
      dispatch(
        updateLogin({
          loginProgress,
          verUser,
          username,
          token,
        }),
      )
    }
    message.success('Please update your password')
  } catch (error) {
    localStorage.clear()
    sessionStorage.clear()
    message.error('User not found...')
    dispatch(fetchLoginFailed())
  }
}

export const resendCode = (username: string) => async (dispatch) => {
  try {
    dispatch(fetchLogin())
    const resetVerification = await usersResendCode(username)

    const { loginProgress, status, token, verUser } = resetVerification

    if (status === 'ok') {
      dispatch(
        setLogin({
          loginProgress,
          verUser,
          username,
          token,
        }),
      )
    }
    message.success('BNBGuard Login Authorisation Code Has Been Resent')
  } catch (error) {
    localStorage.clear()
    sessionStorage.clear()
    message.error('User not found...')
    dispatch(fetchLoginFailed())
  }
}

export const resendAlternateCode = (username: string) => async (dispatch) => {
  try {
    dispatch(fetchLogin())
    const alternateVerification = await usersResendAlternateCode(username)

    const { loginProgress, status, token, verUser } = alternateVerification

    if (status === 'ok') {
      dispatch(
        setLogin({
          loginProgress,
          verUser,
          username,
          token,
        }),
      )
    }
    message.success('BNBGuard Authorisation Code Has Been Resent')
  } catch (error) {
    localStorage.clear()
    sessionStorage.clear()
    message.error('Alternate method failed')
    dispatch(fetchLoginFailed())
  }
}

export const updatePasswords = (password: string, token: string, username: string) => async (dispatch) => {
  try {
    dispatch(fetchLogin())

    const changePassword = await passwordUpdate(token, username, password)
    const { loginProgress, status, verUser } = changePassword

    if (status === 'ok') {
      dispatch(
        updateLogin({
          loginProgress,
          verUser,
          username,
          token,
        }),
      )
    }
    message.success('Your password has been reset. Please login to continue.')
  } catch (error) {
    localStorage.clear()
    sessionStorage.clear()
    message.error('User not found...')
    dispatch(fetchLoginFailed())
  }
}

export const updateProgress =
  (loginProgress: string, verUser: boolean, username: string, token: string) => async (dispatch) => {
    try {
      dispatch(fetchLogin())

      dispatch(
        updateLogin({
          loginProgress,
          verUser,
          username,
          token,
        }),
      )
      // localStorage.setItem('bba-token', JSON.stringify(accessToken))
      // const { _id, shortName, isAdmin, role, userId, username, phonenumber, pic } = accessToken
    } catch (error) {
      localStorage.clear()
      sessionStorage.clear()
      message.error('User not found...')
      dispatch(fetchLoginFailed())
    }
  }

export const { fetchLoginFailed, fetchLogin, setLogin, updateLogin } = loginProgressSlice.actions

export default loginProgressSlice.reducer
